import { atom } from 'recoil';
import { IConfigEntry } from '@shared/types/parts';

export interface ICartItem {
  Sku: string;
  Description: string;
  quantity: number;
  notes: string;
  price: number;
  config: IConfigEntry[];
}

// Get initial cart state from localStorage
const getInitialCart = (): ICartItem[] => {
  try {
    const savedCart = localStorage.getItem('shoppingCart');
    return savedCart ? JSON.parse(savedCart) : [];
  } catch (e) {
    console.error('Error loading cart from localStorage:', e);
    return [];
  }
};

export const shoppingCartAtom = atom<ICartItem[]>({
  key: 'shoppingCart',
  default: getInitialCart(),
  effects: [
    ({ onSet }) => {
      onSet((newValue) => {
        localStorage.setItem('shoppingCart', JSON.stringify(newValue));
      });
    },
  ],
});
